import { useCallback, useState } from "react";
import { Account, useAppDispatch, useAppSelector, AppConfiguration, LocalAccountStorage, AccountRecoveryReminder, useExpireUsersDevicesKeysMutation, useAuthContext } from "src/common";
import { accountActions, mailActions, driveActions, websocketActions, uiActions, settingsActions, adminActions } from "src/store";
import { RootState } from "src/store/configureStore";

export function useLogout() {
    const current_account = useAppSelector((state: RootState) => state.account.current_account);
    const [logged_out, setLoggedOut] = useState<boolean>(false);
    const [expireKey] = useExpireUsersDevicesKeysMutation();
    const { setProfile } = useAuthContext();
    const dispatch = useAppDispatch();


    // Description: Trigger Device Key Expiration for Express accounts
    // https://github.com/PreVeil/core/blob/dev/collection_server/docs/device_keys.md#post-usersdeviceskeysdevice_idexpire
    function handleExpireDeviceKeyCS(_account: Account) {
        const device_id = _account.current_device_id;
        expireKey({
            account_ids: Account.getAccountIdentifiers(_account),
            body: {
                device_id
            }
        }).unwrap()
            .then((_response: unknown) => {
                handleClientLogout();
            })
            .catch((_errors: unknown) => {
                handleClientLogout();
            });
    }

    // Description: Completely logout user from state, sessions and cookies after server device key expiration
    function handleClientLogout() {
        dispatch(accountActions.logout());
        dispatch(mailActions.destroyMail());
        dispatch(driveActions.destroyDrive());
        dispatch(websocketActions.destroyWebsocket());
        dispatch(uiActions.destroyUIManager());
        dispatch(settingsActions.destroySettings());
        dispatch(adminActions.destroyAdmin());
        setProfile();
        LocalAccountStorage.destroyLocalStorageSessions();
        LocalAccountStorage.removeTemporaryCookies("express_recovery_not_setup", "false");
        LocalAccountStorage.removeTemporaryCookies(AccountRecoveryReminder.EXPRESS_RECOVERY_REMIND_LATER, "false");
        setLoggedOut(true);
    }

    const handleStateLogout = useCallback(() => {
        (AppConfiguration.buildForExpress() && !!current_account) ? handleExpireDeviceKeyCS(current_account) : handleClientLogout();
    }, []);

    return {
        handleStateLogout,
        logged_out
    };
}